// v3.8.0之后和移动端公用

var $ = require('jquery'),
  _ = require('underscore'),
  tmpl = require('./tmpl.handlebars')

function fetchSubRank(subRankListUrl,gameCode) {
  $.ajax({
    url: 'https://api.17173.com/merge-interface/v1/game-rank',
    dataType: "jsonp",
    data: {
      gameCode: gameCode,
      rankingUrl: subRankListUrl
    },
    success: function (d) {
      $('.mod-mater-plate .rank').html('<div class="plate"><a href="'+d.data.rankingUrl+'" title="'+d.data.rankingName+'" target="_blank"><span class="c1">'+d.data.rankingName+'</span><span class="c2">第<b>'+d.data.rank+'</b>名</span></a></div>')   
    }
  })
}

function fetchGameRankInfo(gameCode) {
  return $.ajax({
    url: '//d.17173cdn.com/game-top/info/js/' + gameCode + '.js',
    dataType: 'script',
    scriptCharset: 'utf-8',
    cache: true
  })
}

function renderRankView(placeholder, currentTopInfo,gameCode) {
  var rankName, rankUrl, isOnlineGame = false,subRankListUrl
  if (currentTopInfo.rank_type === 'NEW') {
    rankName = '新游期待榜'
    rankUrl = '//top.17173.com/list-1-0-0-0-0-0-0-0-0-0-1.html'
    subRankListUrl = 'http://top.17173.com/list-1-0-0-0-0-0-0-0-0-0-1.html'
    isOnlineGame = true
  } else if (currentTopInfo.rank_type === 'HOT') {
    rankName = '热门游戏榜'
    rankUrl = '//top.17173.com/list-2-0-0-0-0-0-0-0-0-0-1.html'
    subRankListUrl = 'http://top.17173.com/list-2-0-0-0-0-0-0-0-0-0-1.html'
    isOnlineGame = true
  } else if (currentTopInfo.rank_type === 'EXPECT') {
    rankName = '手游期待榜'
    rankUrl = '//top.17173.com/list-1-0-4-0-0-0-0-0-0-0-1.html'
    subRankListUrl = 'http://top.17173.com/list-1-0-4-0-0-0-0-0-0-0-1.html'
  } else {
    rankName = '手游热门榜'
    rankUrl = '//top.17173.com/list-2-0-4-0-0-0-0-0-0-0-1.html'
    subRankListUrl = 'http://top.17173.com/list-2-0-4-0-0-0-0-0-0-0-1.html'
  }

  var info = {
    rankNumber: currentTopInfo.rank_num,
    rankName: rankName,
    rankUrl: rankUrl,
    voteNumber: currentTopInfo.heats_num,
    hasVoteAct: window.ued.voteActFlag,
    isOnlineGame: isOnlineGame,
    rankUnlessEmpty: !_.isEmpty(currentTopInfo) && currentTopInfo.rank_num,
    subRankListUrl: subRankListUrl
  }

  fetchSubRank(subRankListUrl, gameCode)

  placeholder.replaceWith(tmpl(info))
  if (!$('.mod-mater-plate').children().length) {
    $('.mod-mater-plate').remove()
  }

  if(!isOnlineGame) {
    $('.mod-mater-plate .plate').addClass('tac');
  }


}

module.exports = function (container) {
  var ued = window.ued || {},
    gameCode = ued.gameCode,
    voteSection = container.find('.mod-mater-plate')

  fetchGameRankInfo(gameCode).done(function () {
    var datastore = window.DATASTORE || window.DATASTORELAB || {},
      topInfo = datastore['game-top.info'] || {},
      currentTopInfo = topInfo[gameCode] || {}

    renderRankView(
      voteSection.find('.profile-rank-placeholder'), currentTopInfo,gameCode
    )
  })
}